/* eslint-disable import/prefer-default-export */

import userActionTypes from 'app_modules/user/constants'

export const updateCurrentProfile = profile => ({
  payload: profile,
  type: userActionTypes.UPDATE_CURRENT_PROFILE,
})
